import React, { useState } from 'react';
import clsx from 'clsx';
import useSWR from 'swr';
import useSWRMutation from 'swr/mutation'
import { getPtp, postPtp } from 'src/api';
import { useUser } from 'src/context';
import { usePoster } from '../PosterContext';

const POSTER_SRC = "https://storage.googleapis.com/escape-bar-firebase.appspot.com/static/goty2024/poster5.png";
const POSTER_TITLE = "薩利亞修道院";
const POSTER_DESC = "懸疑重重 超強反轉";

const VARIANT_DESC = "一盞新醅 傾家蕩產";

const PosterModal5 = ({ isOpen, onClose }) => {
  const [showDialog, setShowDialog] = useState(false);

  const { isGameEnabled } = usePoster();

  const { isLogin } = useUser();

  const { data: ptpData, isLoading: ptpLoading, mutate: ptpMutate } = useSWR(isLogin ? `goty2024-ptp` : null, getPtp);

  const { trigger, isMutating } = useSWRMutation(
    isLogin ? `goty2024-ptp` : null, 
    (url, { arg }) => postPtp(arg),
    {
      onSuccess: (res) => {
        ptpMutate();
      },
    }
  );

  const hasWine = ptpData?.data?.wine === 1 || false;
  const isWineGiven = ptpData?.data?.wine === 2 || false;

  const handleImageClick = () => {
    if (isGameEnabled && !isWineGiven) {
      setShowDialog(true);
    }
  };

  const handleDialogFinish = () => {
    setShowDialog(false);
    trigger({
      behavior: "GIVE_WINE",
    });
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[2000] flex items-center justify-center transition-all"
      style={{
        backgroundImage: `url('/img/goty2024/hero-bricks.png')`,
        backgroundRepeat: 'repeat',
        backgroundColor: 'rgba(0,0,0,0.90)',
      }}
      onClick={onClose}
    >
      <button
        className="absolute top-4 right-4 text-white text-3xl font-bold z-60"
        onClick={(e) => { e.stopPropagation(); onClose(); }}
        aria-label="關閉"
      >
        ×
      </button>
      <div
        className="flex flex-col items-center justify-between relative"
        onClick={e => e.stopPropagation()}
      >
        <div
          className="w-[calc(100%+2rem)] md:w-[calc(100%+4rem)] bg-[#DFB750] text-center border-x-8 border-b-8 border-solid border-black mr-[-1rem] ml-[-1rem] md:mr-[-2rem] md:ml-[-2rem]"
        >
          <h2 className="text-2xl md:text-3xl font-bold tracking-wide text-black py-2 md:py-4">
            {POSTER_TITLE}
          </h2>
        </div>
        <div 
          className={clsx("relative w-80 md:w-auto h-auto md:h-[75vh]", {
            'cursor-pointer': isGameEnabled && !isWineGiven
          })}
          onClick={handleImageClick}
        >
          <img src={POSTER_SRC} alt={POSTER_TITLE} className="object-contain w-full h-full mx-auto border-x-8 border-b-8 border-solid border-black shadow-2xl" />
        </div>
        <div className="mt-6 text-center">
          <p className={clsx("text-xl md:text-2xl font-bold tracking-widest shadow-2xl", {
            'text-white': !isGameEnabled,
            'text-black': isGameEnabled
          })}>
            {isGameEnabled ? VARIANT_DESC : POSTER_DESC}
          </p>
        </div>
      </div>

      {/* Dialog */}
      {showDialog && (
        <div className="fixed inset-0 z-[3000] flex items-center justify-center bg-black bg-opacity-50">
          <div
            className="flex flex-col items-center justify-center relative w-full max-w-xs md:max-w-md"
            onClick={e => e.stopPropagation()}
          >
            <div className="w-full flex flex-col justify-center">
              <div className="relative bg-white p-4 md:p-6 rounded-lg shadow-md mb-4">
                <div className="text-black text-center">
                  <div className="mb-4">
                    {hasWine && (
                      <img 
                        src="/img/goty2024/game-wine.PNG" 
                        alt="酒" 
                        className="w-16 h-16 mx-auto mb-3 object-contain"
                      />
                    )}
                    <h3 className="text-lg md:text-xl font-bold mb-2">「{hasWine ? "你有酒！今晚讓我們不醉不休！" : "你有醉嗎？我還沒醉 ..."}」</h3>
                    <p className="text-sm md:text-base">
                      {hasWine ? <>這傢伙是認真的嗎？居然喝個爛醉<br/>
                        他非常滿意地拿出一枚金幣送你當作謝禮<br/>
                        你覺得這枚金幣應該可以在哪裡派上用場</> 
                        : <>你覺得這傢伙怪怪的<br/>決定先離他遠點</>
                      }
                    </p>
                  </div>
                </div>
              </div>
              <div className="w-full">
                <button
                  onClick={hasWine ? handleDialogFinish : () => setShowDialog(false)}
                  className="w-full p-3 md:p-4 text-center border-2 border-[#7B2337] rounded-lg transition-all duration-300 bg-white text-[#7B2337] hover:bg-[#7B2337] hover:text-white font-bold"
                >
                  {hasWine ? "先收起來" : "四處逛逛"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PosterModal5;
